import script from "./PersonalizedEmailsViewV2.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalizedEmailsViewV2.vue?vue&type=script&setup=true&lang=js"

import "./PersonalizedEmailsViewV2.vue?vue&type=style&index=0&id=001b50ac&lang=scss"

const __exports__ = script;

export default __exports__